export function SiteBackground({ children }: { children: React.ReactNode }) {
	return <div className="min-h-screen bg-background text-foreground">{children}</div>;
}
